'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_AcceptedRequestProvidedEPSCode$Provided(code) {
  this.Lapp_data_AcceptedRequestProvidedEPSCode$Provided__f_code = null;
  this.Lapp_data_AcceptedRequestProvidedEPSCode$Provided__f_code = code;
}
export { $c_Lapp_data_AcceptedRequestProvidedEPSCode$Provided as $c_Lapp_data_AcceptedRequestProvidedEPSCode$Provided };
$c_Lapp_data_AcceptedRequestProvidedEPSCode$Provided.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_AcceptedRequestProvidedEPSCode$Provided.prototype.constructor = $c_Lapp_data_AcceptedRequestProvidedEPSCode$Provided;
/** @constructor */
function $h_Lapp_data_AcceptedRequestProvidedEPSCode$Provided() {
}
export { $h_Lapp_data_AcceptedRequestProvidedEPSCode$Provided as $h_Lapp_data_AcceptedRequestProvidedEPSCode$Provided };
$h_Lapp_data_AcceptedRequestProvidedEPSCode$Provided.prototype = $c_Lapp_data_AcceptedRequestProvidedEPSCode$Provided.prototype;
$c_Lapp_data_AcceptedRequestProvidedEPSCode$Provided.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_data_AcceptedRequestProvidedEPSCode$Provided.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1748828456), true);
});
$c_Lapp_data_AcceptedRequestProvidedEPSCode$Provided.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lapp_data_AcceptedRequestProvidedEPSCode$Provided) && (this.Lapp_data_AcceptedRequestProvidedEPSCode$Provided__f_code === x$0.Lapp_data_AcceptedRequestProvidedEPSCode$Provided__f_code)));
});
$c_Lapp_data_AcceptedRequestProvidedEPSCode$Provided.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_data_AcceptedRequestProvidedEPSCode$Provided.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_data_AcceptedRequestProvidedEPSCode$Provided.prototype.productPrefix__T = (function() {
  return "Provided";
});
$c_Lapp_data_AcceptedRequestProvidedEPSCode$Provided.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_data_AcceptedRequestProvidedEPSCode$Provided__f_code;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_data_AcceptedRequestProvidedEPSCode$Provided.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "code";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_data_AcceptedRequestProvidedEPSCode$Provided(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_data_AcceptedRequestProvidedEPSCode$Provided)));
}
export { $isArrayOf_Lapp_data_AcceptedRequestProvidedEPSCode$Provided as $isArrayOf_Lapp_data_AcceptedRequestProvidedEPSCode$Provided };
var $d_Lapp_data_AcceptedRequestProvidedEPSCode$Provided = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_AcceptedRequestProvidedEPSCode$Provided, "app.data.AcceptedRequestProvidedEPSCode$Provided", ({
  Lapp_data_AcceptedRequestProvidedEPSCode$Provided: 1,
  Lapp_data_AcceptedRequestProvidedEPSCode: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_data_AcceptedRequestProvidedEPSCode$Provided as $d_Lapp_data_AcceptedRequestProvidedEPSCode$Provided };
//# sourceMappingURL=app.data.-Accepted-Request-Provided-E-P-S-Code$-Provided.js.map
